import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tag18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.9999 5C13.9999 5.55228 13.5522 6 12.9999 6C12.4477 6 11.9999 5.55228 11.9999 5C11.9999 4.44772 12.4477 4 12.9999 4C13.5522 4 13.9999 4.44772 13.9999 5Z'
      fill='currentColor'
    />
    <path
      d='M7.4696 6.53033L11.4696 10.5303L12.5303 9.46967L8.53026 5.46967L7.4696 6.53033Z'
      fill='currentColor'
    />
    <path
      d='M8.4696 12.5303L5.4696 9.53033L6.53026 8.46967L9.53026 11.4697L8.4696 12.5303Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.28395 1.25C8.95243 1.25 8.63449 1.3817 8.40007 1.61612L0.823148 9.19304C0.334992 9.6812 0.334993 10.4727 0.823148 10.9608L7.03912 17.1768C7.52727 17.6649 8.31873 17.6649 8.80688 17.1768L16.3838 9.59985C16.6182 9.36543 16.7499 9.04749 16.7499 8.71597V2.5C16.7499 1.80964 16.1903 1.25 15.4999 1.25H9.28395ZM2.06058 10.0769L9.38751 2.75H15.2499V8.61242L7.923 15.9393L2.06058 10.0769Z'
      fill='currentColor'
    />
  </Svg>
);

Tag18.displayName = 'Tag18';
export default Tag18;
